import paymentService from '@/services/payment.service'
import store from '@/store'

export const payment_inprogress = {
  namespaced: true,
  state: {
    now: (new Date()),
    paymentIngoing: 0,
    intervalTimer: null,
  },
  actions: {
    pollNow({ commit, state }) {
      if(!state.intervalTimer) {
        commit('setIntervalTimer', () => commit('now'))
      }
    },
    clearPollNow({ commit, state }) {
      if(state.intervalTimer) {
        commit('clearIntervalTimer')
        state.intervalTimer = 0
      }
    },
  },
  mutations: {
    now(state) {
      paymentService.get(store.state.profil.user, {status: 0})
      .then((response) => {
        if(response.payments.length) {
          state.paymentIngoing = response.payments[0]
        } else {
          state.paymentIngoing = null
        }
      })
    },
    setIntervalTimer(state, callback) {
      callback()

      state.intervalTimer = setInterval(() => {
        if(callback) {
          callback()
        }
      }, 2500)
    },
    clearIntervalTimer(state) {
      if(state.intervalTimer) {
        clearInterval(state.intervalTimer)
      }
    }
  }
};
